import { render } from "./VariantInfo.vue?vue&type=template&id=715f07f3"
import script from "./VariantInfo.vue?vue&type=script&lang=js"
export * from "./VariantInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__